import type { LC_UpdateSecurityGroupingOut, UpdateSecurityGroupingResult } from '../types';


export function mapUpdatedSecurityGroupingToModel(
  transport: LC_UpdateSecurityGroupingOut,
): UpdateSecurityGroupingResult {
  return {
    id: transport.id,
    code: transport.code,
    name: transport.groupName,
    sendsAttendanceStatus: transport.sendsAttendanceStatus,
    isActive: transport.enabled,
  };
}
